<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title mdi mdi-wallet-membership"> Membership Plans</h4>
                <h6 class="card-subtitle">Manage membership plans for growers</h6>
            </div>
            <div class="card-body card-blue collapse show" v-if="plans.length > 0">
                <div class="table-responsive">
                    <table class="table no-wrap v-middle">
                        <thead>
                        <tr class="border-0">
                            <th class="border-0">Plan</th>
                            <th class="border-0">Fee</th>
                            <th class="border-0">Payment Schedule</th>
                            <th class="border-0">Members</th>
                            <th class="border-0">Status</th>
                            <th class="border-0">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(plan, index) in plans">
                            <td>{{plan.name}}</td>
                            <td>{{plan.fee | currency(plan.currency)}}</td>
                            <td>{{plan.schedule}}</td>
                            <td>{{plan.count}}</td>
                            <td>
                                <span class="label label-info" v-if="plan.status === 'READY'">READY</span>
                                <span class="label label-dark-green" v-if="plan.status === 'ACTIVE'">ACTIVE</span>
                                <span class="label label-grey" v-if="plan.status === 'RETIRED'">RETIRED</span>
                            </td>
                            <td>
                                <router-link :to="{name: 'viewplan', params : {planid: plan.id}}"><h6>View</h6></router-link>
                                <a><b></b></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
            <div class="card-body card-blue" v-else>
                <h4 class="card-title text-muted text-center">No records found</h4>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Create New Plan</h4>
            </div>

            <form @submit.prevent="handleSubmit" class="form-horizontal" id="membership-form">
                <div class="card-body card-blue">
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="plan_name">Name</label>
                        <div class="col-sm-6">
                            <input :class="{'is-invalid': submitted && errors.has('plan_name')}" class="form-control"
                                   data-vv-as="Name"
                                   id="plan_name"
                                   name="plan_name"
                                   placeholder="Plan Name"
                                   type="text"
                                   v-model="plan_name"
                                   v-validate="'required'">
                            <div class="invalid-feedback" v-if="submitted && errors.has('plan_name')">{{ errors.first('plan_name') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="plan_description">Description</label>
                        <div class="col-sm-6">
                            <textarea :class="{'is-invalid': submitted && errors.has('plan_description')}" class="form-control"
                                      data-vv-as="Description"
                                      id="plan_description"
                                      name="plan_description"
                                      placeholder="Plan Description"
                                      type="text"
                                      v-model="plan_description"
                                      v-validate="'required'"></textarea>
                            <div class="invalid-feedback" v-if="submitted && errors.has('plan_description')">{{ errors.first('plan_description') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="plan_fee">Fee</label>
                        <div class="col-sm-6">
                            <input :class="{'is-invalid': submitted && errors.has('plan_fee')}" class="form-control"
                                   data-vv-as="Fee"
                                   id="plan_fee"
                                   name="plan_fee"
                                   placeholder="Plan Fee"
                                   type="number"
                                   step="any"
                                   v-model="plan_fee"
                                   v-validate="'required'">
                            <div class="invalid-feedback" v-if="submitted && errors.has('plan_fee')">{{ errors.first('plan_fee') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label">Currency</label>
                        <div class="col-sm-6">
                            <div :class="{'is-invalid': submitted && errors.has('plan_currency')}" class="form-control p-0-0">
                                <currency-select @currency-select="setCurrency"
                                                 data-vv-as="Currency"
                                                 id="plan_currency"
                                                 name="plan_currency"
                                                 ref="plan_currency"
                                                 v-model="plan_currency"
                                                 v-validate="'required'">
                                </currency-select>
                            </div>
                            <div class="invalid-feedback" v-if="submitted && errors.has('plan_currency')">{{ errors.first('plan_currency') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label">Schedule</label>
                        <div class="col-sm-6">
                            <div class="form-check">
                                <input :class="{'is-invalid': submitted && errors.has('plan_schedule')}"
                                       class="form-check-input"
                                       data-vv-as="Schedule"
                                       id="plan_schedule_monthly"
                                       name="plan_schedule"
                                       type="radio"
                                       v-model="plan_schedule"
                                       v-validate="'required'"
                                       value="MONTHLY">
                                <label class="form-check-label" for="plan_schedule_monthly">Monthly<br>
                                    <small> Members will be billed on <b>Monthly</b> basis</small>
                                </label>
                            </div>
                            <div class="form-check">
                                <input :class="{'is-invalid': submitted && errors.has('plan_schedule')}"
                                       class="form-check-input"
                                       data-vv-as="Schedule"
                                       id="plan_schedule_yearly"
                                       name="plan_schedule"
                                       type="radio"
                                       v-model="plan_schedule"
                                       v-validate="'required'"
                                       value="YEARLY">
                                <label class="form-check-label" for="plan_schedule_yearly">Yearly<br>
                                    <small> Members will be billed on <b>Yearly</b> basis</small>
                                </label>
                            </div>
                            <div class="invalid-feedback" style="display: block;" v-if="submitted && errors.has('plan_schedule')">{{ errors.first('plan_schedule') }}</div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="form-group m-b-0 text-right">
                        <div class="button-group">
                            <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                            <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import CurrencySelect from '../../common/CurrencySelect';
    import Paginate from 'vuejs-paginate';

    export default {
        name: "MembershipPlan",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {CurrencySelect, Paginate},
        data() {
            return {
                submitted: false,
                plans: [],
                plan_name: null,
                plan_description: null,
                plan_fee: null,
                plan_currency: null,
                plan_schedule: null,
                pageCount: 1,
                total: 0,
            }
        },
        mounted() {
            this.getPlans();
        },
        methods: {
            async getPlans() {
                $(".preloader").fadeIn();
                let reply  = await this.$http.get(`marketplaces/${this.currentOrg.marketplace_id}/plans`);
                $(".preloader").fadeOut();
                this.plans = reply.data.plans;
                this.total = reply.data.total;
                this.setPageCount();
            },
            async savePlan() {
                let plan = {
                    name: this.plan_name,
                    description: this.plan_description,
                    fee: this.plan_fee,
                    currency_id: this.plan_currency.id,
                    schedule: this.plan_schedule
                };

                try {
                    await this.$http.put(`marketplaces/${this.currentOrg.marketplace_id}/plans`, plan);
                    this.$toastr('success', `Plan ${plan.name} successfully added`, 'Plan Added');
                } catch(e) {
                    console.error(e);
                    this.$toastr('error', 'Could not save plan', 'Failed');
                    throw e;
                }
            },
            async handleSubmit() {
                this.submitted = true;

                try {
                    let valid = await this.$validator.validate();
                    if(valid) {
                        await this.savePlan();
                        this.reset();
                        await this.getPlans();
                    }
                } catch(e) {
                    console.error(e);
                }
            },
            reset() {
                this.submitted                    = false;
                this.plan_name                    = null;
                this.plan_description             = null;
                this.plan_fee                     = null;
                this.plan_currency                = null;
                this.plan_schedule                = null;
                this.$refs.plan_currency.currency = null;
            },
            setCurrency(e) {
                if(e) {
                    this.plan_currency = e;
                } else {
                    this.plan_currency = null;
                }
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            pageHandler(pageNum) {
                this.getPlans(pageNum);
            },
        }
    }
</script>

<style scoped>

</style>
